/* eslint-disable camelcase */
import {
  CriticalDatasetLabels,
  HumanEntryGlasses,
  HumanEntryHair,
  HumanEntrySex,
  HumanEntryWearingType
} from '../../enum'

import Vuetify from '../../plugins/vuetify'

const _t = (text) => Vuetify.framework.lang.t(text)

export class HumanEntry {
  constructor ({
    sex = HumanEntrySex.MALE, glasses = HumanEntryGlasses.NONE,
    wearing_type = HumanEntryWearingType.SINGLE_COLORED, wearing_type_comment = '',
    wearing_color_belt_similar = false, hair = HumanEntryHair.SHORT
  } = {}) {
    this.sex = sex // enums.HumanEntrySex
    this.glasses = glasses // enums.HumanEntryGlasses
    this.wearingType = wearing_type // enums.HumanEntryWearingType
    this.wearingTypeComment = wearing_type_comment // string
    this.wearingColorBeltSimilar = wearing_color_belt_similar // boolean
    this.hair = hair === HumanEntryHair.LONG_HIDING // enums.HumanEntryHair // HumanEntryHair.SHORT.value
  }

  filters () {
    const result = {}
    for (const field of Object.keys(this)) {
      result[field] = false
    }
    return result
  }

  backendModel () {
    return {
      sex: this.sex,
      glasses: this.glasses,
      wearing_type: this.wearingType,
      wearing_color_belt_similar: this.wearingColorBeltSimilar,
      wearing_type_comment: this.wearingTypeComment,
      hair: this.hair ? HumanEntryHair.LONG_HIDING : HumanEntryHair.SHORT
    }
  }

  get textRepresentation () {
    const result = []

    result.push(_t(`$vuetify.criticalDataset.enums.HumanEntrySex.${this.sex}`))

    if (this.glasses !== HumanEntryGlasses.NONE) {
      result.push(_t(`$vuetify.criticalDataset.enums.HumanEntryGlasses.${this.glasses}`))
    }

    if (this.wearingColorBeltSimilar) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.HUMAN}.wearingColorBeltSimilarDataset`))
    }

    if (this.hair) {
      result.push(_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.HUMAN}.hairDataset`))
    }

    return result.map(item => ({
      item,
      color: 'blue',
      type: CriticalDatasetLabels.HUMAN
    }))
  }
}
